import { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ComponentPropsExtenderSymbol } from 'feature-components'
import { VerticalMenus, ExpandableAndDropdownMenus } from './menusCurrentPage'

export const page: ContainerModuleLoader = (bind) => {
	bind(ComponentPropsExtenderSymbol).to(VerticalMenus)
	bind(ComponentPropsExtenderSymbol).to(ExpandableAndDropdownMenus)
}
